import {
  TRANSACTION_FETCH,
  TRANSACTION_FETCH_SUCCESS,
  TRANSACTION_FETCH_FAIL,
  TRANSACTION_SUMMARY_FETCH,
  TRANSACTION_SUMMARY_FETCH_SUCCESS,
  TRANSACTION_SUMMARY_FETCH_FAIL,
  TRANSACTION_MONTHLY_FETCH,
  TRANSACTION_MONTHLY_FETCH_SUCCESS,
  TRANSACTION_MONTHLY_FETCH_FAIL
} from '../actions';

export const transactionFetch = (transaction, history, desiredPath) => ({
  type: TRANSACTION_FETCH,
  payload: { transaction, history, desiredPath }
});

export const transactionSuccess = (transaction) => ({
  type: TRANSACTION_FETCH_SUCCESS,
  payload: transaction
});

export const transactionFail = (message) => ({
  type: TRANSACTION_FETCH_FAIL,
  payload: { message }
});

export const transactionSummaryFetch = (transactionSummary) => ({
  type: TRANSACTION_SUMMARY_FETCH,
  payload: { transactionSummary }
});

export const transactionSummarySuccess = (transactionSummary) => ({
  type: TRANSACTION_SUMMARY_FETCH_SUCCESS,
  payload: { transactionSummary }
});

export const transactionSummaryFail = (message) => ({
  type:   TRANSACTION_SUMMARY_FETCH_FAIL
,
  payload: { message }
});

export const transactionMonthlyFetch = (monthly) => ({
  type: TRANSACTION_MONTHLY_FETCH,
  payload: { monthly }
});

export const transactionMonthlySuccess = (monthly) => ({
  type: TRANSACTION_MONTHLY_FETCH_SUCCESS,
  payload: monthly
});

export const transactionMonthlyFail = (message) => ({
  type: TRANSACTION_MONTHLY_FETCH_FAIL,
  payload: { message }
});
